// AG Grid CSS must load before globals.css so the app's grid overrides win
// on equal-specificity ties (restores the pre-Vite cascade order).
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "@/styles/globals.css";
import "react-toastify/dist/ReactToastify.css";
import "quill/dist/quill.core.css";
import "ag-grid-enterprise";
import "ag-charts-enterprise";
// Side effect: registers the AG Grid + AG Charts enterprise licenses.
import "@/lib/agGridLicense";

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
